module.exports = __webpack_public_path__ + "static/media/illustration-rptstd-create.cf205f24.svg";